import React, { useEffect, useMemo } from 'react';
import { FormikValues } from 'formik';
import { provide } from '@hilma/tools';
import { FormInput, FormProvider, useForm, useOnSubmitRef } from '@hilma/netina2all';

import { loginDialogRules } from '../../../constants';
import { useI18n } from '../../../hooks';

import { useStyles } from './LoginDialog';

interface CodeProps {
	phone: string;
	formRef: React.MutableRefObject<ReturnType<typeof useForm> | null>;
	onLoginWithCodeSubmit(values: FormikValues): Promise<void>;
}

const Code: React.FC<CodeProps> = (({ phone, formRef, onLoginWithCodeSubmit }) => {
	const form = useForm();
	const onSubmitRef = useOnSubmitRef();

	const pd = useI18n(i18n => i18n.pd);

	const classes = useStyles();

	const codeSent = useMemo(() => (
		`${pd.codeSent1} ${phone} ${pd.codeSent2}`
	), [phone, pd]);

	useEffect(() => {
		form.setFieldError('code', undefined);
	}, []);

	useEffect(() => {
		formRef.current = form;
	}, [form]);

	useEffect(() => {
		onSubmitRef.current = onLoginWithCodeSubmit;
	}, [onLoginWithCodeSubmit]);

	return (
		<div>
			<div className={classes.text}>{codeSent}</div>
			<FormInput
				autoFocus
				id="code"
				description={pd.none}
				autoComplete="off"
			/>
		</div>
	);
});

export default provide(
	[FormProvider, { initialValues: { code: '' }, rules: loginDialogRules }]
)(Code);